'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

const mediaPrefersReducedMotion = styled.css`
  @media (prefers-reduced-motion) {
    animation: none !important;
    transition: none !important;
  }
`;

exports.mediaPrefersReducedMotion = mediaPrefersReducedMotion;
//# sourceMappingURL=media-queries.js.map
